// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__tYrT2","container":"styles_container__tNQ_n","inverted":"styles_inverted__E71NI"};